import type {ReactElement} from 'react';
import {resolveChatMediaUrl} from '@Libraries/chat-media-url.library';
import {MediaItemSizeType} from '@Libraries/s3-library';
import {MediaCountBadge} from '@Components/ai-chat-window/components/entity-card/components/media-count-badge/media-count-badge';
import type {EntityCardThumbnailProps} from './entity-card-thumbnail.types';
import styles from './entity-card-thumbnail.module.scss';

export function EntityCardThumbnail({altText, mediaUrl, icon, mediaCount}: EntityCardThumbnailProps): ReactElement | null {
  const resolvedMediaUrl = resolveChatMediaUrl(mediaUrl, MediaItemSizeType.THUMB);

  if (resolvedMediaUrl !== null) {
    return (
      <div className={styles.entityCardThumbnail}>
        <img className={styles.thumbnailBackdrop} src={resolvedMediaUrl} alt="" aria-hidden="true" />
        <div className={styles.thumbnailBlur} aria-hidden="true" />
        <img className={styles.thumbnailImage} src={resolvedMediaUrl} alt={altText} />
        <MediaCountBadge mediaCount={mediaCount} />
      </div>
    );
  }

  if (icon !== undefined && icon !== '') {
    return (
      <div className={`${styles.entityCardThumbnail} ${styles.iconThumbnail}`}>
        <i className={`${icon} ${styles.iconGlyph}`} aria-hidden="true" />
      </div>
    );
  }

  return null;
}
